import * as actionTypes from '../../action-types';
import * as actionParams from '../../action-params';

class GoogleTagManager {

  events = new Map([
    [actionTypes.cartViewed, actionParams.cartViewed],
    [actionTypes.productRemoved, actionParams.productRemoved],
    [actionTypes.checkoutStep, actionParams.checkoutStep],
    [actionTypes.productViewed, actionParams.productViewed],
    [actionTypes.productListViewed, actionParams.productListViewed],
    [actionTypes.checkoutStepViewed, actionParams.checkoutStepViewed],
    [actionTypes.checkoutStepViewedPayment, actionParams.checkoutStepViewedPayment],
    [actionTypes.orderCompleted, actionParams.orderCompleted],
    [actionTypes.productAdded, actionParams.productAdded],
    [actionTypes.productClicked, actionParams.productClicked],
    [actionTypes.cartDetailEvent, actionParams.cartDetailEvent],
    [actionTypes.promotionViewed, actionParams.promotionViewed],
    [actionTypes.promotionClick, actionParams.promotionClick],
    [actionTypes.loginAction, actionParams.loginAction],
    [actionTypes.signUpAction, actionParams.signUpAction],
  ]);

  constructor(config) {
    this.config = config;
  }

  loadScript() {
    return new Promise((res, rej) => {
      const gtmURL = this.config.sgtmURL || 'https://www.googletagmanager.com/gtm.js';
      $.getScript(
        `${gtmURL}?id=${this.config.key}`,
      )
        .done(() => {
          res();
        })
        .fail(rej);
    });
  }

  push(action) {
    if (action.type === actionTypes.identify) {
      this.identify(action.data);
      return;
    }

    if(action.type === actionTypes.pageViewed){
      this.pageViewed(action.data);
      return;
    }

    if (action.type === actionTypes.gtmStart){
      this.gtmStart();
      return;
    }

    this.track(action);

  }

  identify(userData) {
    const { id, user: { email, signupDate, loginDate, gender, permission, smsPermission, memberTypes, userIsNew } } = userData;
    const data = {
      cd_userId: id,
      cd_userEmail: email,
      cd_userSignupDate: signupDate,
      cd_userGender: gender,
      cd_userEmailPermission: permission
    };

    if (smsPermission) {
      data.cd_userSMSPermission = smsPermission;
    }

    if (loginDate) {
      data.cd_userLoginDate = loginDate;
    }

    if (memberTypes) {
      data.cd_memberTypes = memberTypes;
    }

    if (userIsNew) {
      data.cd_userIsNew = userIsNew;
    }

    window.dataLayer.push(data);
  }

  pageViewed(pageData) {
    const cd_pageCategory = window.location.pathname.split('/')[1];
    const data = {
      cd_pageType: pageData,
      cd_pageCategory
    };

    if (typeof pageData === 'object') {
      let { pageType, pageBreadcrumb } = pageData;
      data.cd_pageType = pageType;

      if (pageBreadcrumb.length) {
        data.cd_pageBreadcrumb = pageBreadcrumb;
      }
    }

    window.dataLayer.push(data);
  }

  gtmStart(){
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
  }

  track(action) {
    if (!action.type) return;

    const params = this.events.get(action.type);

    if (!params.typeKey){
      const data = {
        ...actionParams.common,
        ...params.common,
      };
      window.dataLayer.push(data);
      return;
    }

    const data = {
      ...actionParams.common,
      ...params.common,
      ecommerce: {
        [params.typeKey]: params.valueType instanceof Array ? [...action.payload] : {...action.payload},
      }
    };

    if (params.actionField){
      data.ecommerce[params.typeKey] = {
        actionField : {...params.actionField},
        ...data.ecommerce[params.typeKey]
      }
    }

    window.dataLayer.push(data);
  }
}

export default GoogleTagManager;
